<template>
  <div>
    <div>
      <p>
        <span>Please enter your contact information below and click on 'Next'. We will send you a login code to your new contact information.</span> <br />
        <span>
          Login code will be valid for limited time. Enter the login code on the following screen and upon successful login code validation your contact information will be updated and you will be navigated
          to your RI DMV Online Customer profile. Your contact information will be used for future electronic Multi Factor Authentication (MFA).
        </span>
      </p>
      <div class="component-container" v-if="updateContact">
        <div v-if="updateContact.email">
          <ContactEmail :verify="verify" @doEmail="setEmail" @doResetVerify="resetVerify" :embedded="true" ref="ContactEmail" @click.right.prevent :isRequired="false"/>
          <span class="app-error-msg" v-if="!isValidMyEmail">
            {{errMsgEmail}}
          </span>
          <ContactEmail :verify="verify" @doEmail="setConfirmEmail" @doResetVerify="resetVerify" :embedded="true" titleEmail="Confirm Email" userEmail="ConfirmEmail" ref="ContactReenterEmail" @click.right.prevent :isRequired="false"/>
          <span class="app-error-msg" v-if="!isValidConfirmEmail">
            {{errMsgConfirmEmail}}
          </span>
          <span class="app-error-msg" v-if="!validateEmail && errMsgCommon" >
            {{errMsgCommon}}
          </span>
        </div>
        <div v-if="updateContact.phone">
          <ContactPhone :verify="verify" @doPhone="setPhone" @doResetVerify="resetVerify" :embedded="true" ref="ContactPhone" @click.right.prevent titlePhone="Phone (Message and data rates may apply)"/>
          <span class="app-error-msg" v-if="!isValidMyPhone">
            {{errMsgPhone}}
          </span>
          <ContactPhone :verify="verify" @doPhone="setConfirmPhone" @doResetVerify="resetVerify" :embedded="true" titlePhone="Confirm Phone" ref="ContactReenterPhone" @click.right.prevent/>
          <span class="app-error-msg" v-if="!isValidConfirmPhone">
            {{errMsgConfirmPhone}}
          </span>
          <span class="app-error-msg" v-if="!validatePhone && errMsgCommonPhone">
            {{errMsgCommonPhone}}
          </span>
        </div>  
      </div>
      <BaseButtonGroup>
        <button type="button" @click="handleRouting('previous')">Previous</button>
        <!-- <button type="submit" class="app-btn-primary" @click.prevent="handleRouting('next')">
          Next
        </button> -->
        <CustomButton @click="handleRouting('next')">
          Next
        </CustomButton>
      </BaseButtonGroup>
    </div>
  </div>
</template>



<script>
import * as COMMONS from '../../store/_commons';
import { mapGetters, mapActions } from 'vuex';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';
import ContactPhone from '@/components/contact/ContactPhone'
import ContactEmail from '@/components/contact/ContactEmail';
import { phoneMixin } from '@/utils/phoneMixin';
import CustomButton from '../CustomButton.vue';

export default {
  name: 'MFA',
  components: {
    BaseButtonGroup,
    ContactPhone,
    ContactEmail,
    CustomButton
  },
  data() {
    return {
      screenData: {},
      myPhoneAC: '',
      myPhoneF3: '',
      myPhoneL4: '',
      myEmail: '',
      myPhone: '',
      myConfirmEmail: '',
      myConfirmPhone: '',
      errorMsg:'',
      verify: true,
      isComponentValid: true,     // this parent's validations
      isPhoneValidated: true,     // from ContactPhone
      isEmailValidated: true,     // from ContactEmail
      isConfirmEmailValidated: true,
      isConfirmPhoneValidated: true,
      errMsg: '',
      isValidMyEmail: true,
      isValidConfirmEmail: true,
      isValidMyPhone: true,
      isValidConfirmPhone: true,
      validateEmail: true,
      validatePhone: true,
      errMsgCommon: '',
      errMsgEmail: '',
      errMsgConfirmEmail: '',
      errMsgPhone: '',
      errMsgConfirmPhone: '',
      errMsgCommonPhone: ''
    }
  },
  mixins: [
    phoneMixin,
  ],
  computed: {
    ...mapGetters({
        personalInfo: COMMONS.GUEST_PERSONAL_INFO,
    }),
    updateContact() {
      return this.$store.state.guestLogin.updateContact;
    },
    contactInfo() {
      return this.$store.state.guestLogin.loginUserDetails;
    }
  },
  created() {

  },
  mounted() {
    if(this.updateContact.email) {
      const pasteBox = document.getElementById("ConfirmEmail"); 
      pasteBox.onpaste = e => { 
        e.preventDefault(); 
        return false; 
      };
    }
    if(this.updateContact.phone) {
      const userPhoneAC = document.getElementById("userPhoneAC"); 
      userPhoneAC.onpaste = e => { 
        e.preventDefault(); 
        return false; 
      };
      const userPhoneF3 = document.getElementById("userPhoneF3"); 
      userPhoneF3.onpaste = e => { 
        e.preventDefault(); 
        return false; 
      };
      const userPhoneL4 = document.getElementById("userPhoneL4"); 
      userPhoneL4.onpaste = e => { 
        e.preventDefault(); 
        return false; 
      };
    }

    window.scroll(0,0);
    document.body.setAttribute("tabindex", "1");
    document.body.focus();

    document.body.removeAttribute("tabindex");
    document.getElementById("app").scrollTop = 0;
  },
  watch: {

  },
  methods: {
    ...mapActions({
      getGuestSendMfaRequest : COMMONS.GUEST_SEND_MFA_REQUEST,
    }),
    async handleRouting(info) {
      if(info=='previous') {
        this.$store.state.guestLogin.contactUpdateStep = 1;
      }
      else if (info=='next') {
        await this.resetValidate();
        this.checkValidate();
        if(this.contactInfo && this.contactInfo.isPaperOtpSent) {
          if((this.myEmail != '' && this.myConfirmEmail !='') || (this.myPhone !='' && this.myConfirmPhone !='')) {
            if(await this.checkValidate()) {
              let data = {
              email: this.myEmail,
              phone: this.formatPhoneForRims(this.myPhone)
            }
            this.getGuestSendMfaRequest(data);
            }
          }
        }
        else {
          this.checkValidate();
          if((this.myEmail != '' && this.myConfirmEmail !='') || (this.myPhone !='' && this.myConfirmPhone !='')) {
            if(await this.checkValidate()) {
              let data = {
                email: this.myEmail,
                phone: this.formatPhoneForRims(this.myPhone)
              }
              this.getGuestSendMfaRequest(data);
            }
          }
        }
      }
    },

    async continueToNextStep() {
      if(this.$refs.ContactPhone.myPhone && this.$refs.ContactPhone.myPhone.length > 0) {
        await this.$refs.ContactPhone.checkPhone();
        this.isPhoneValidated = this.$refs.ContactPhone.invalidPhone;
        if(this.isPhoneValidated) {
          return; 
        }
      }
      this.isComponentValid = ( !this.isPhoneValidated);
    },

    async checkValidate() {

      if(this.updateContact.email) {
        if (this.myEmail == '' || this.myEmail == null){
          this.validateEmail = false;
          this.isValidMyEmail = false;
          this.errMsgEmail = 'Email is required'
        }
        if (this.myConfirmEmail == '' || this.myConfirmEmail == null) {
          this.validateEmail = false;
          this.isValidConfirmEmail = false;
          this.errMsgConfirmEmail = 'Confirm email is required'
        }
        if((this.myEmail !='' && this.myEmail != null ) && (this.myConfirmEmail !='' && this.myConfirmEmail != null)) {
          if(this.myEmail == this.myConfirmEmail) {
            this.validateEmail = true;
          }
          else {
            this.validateEmail = false;
            this.errMsgCommon = 'Email and Confirm email values do not match'
          }
        }
      }
      if(this.updateContact.phone) {
        await this.$refs.ContactPhone.checkPhone();
        await this.$refs.ContactReenterPhone.checkPhone();
        this.isPhoneValidated = await this.$refs.ContactPhone.hasValidPhone();
        this.isConfirmPhoneValidated = await this.$refs.ContactReenterPhone.hasValidPhone();
        if (this.myPhone == '' || this.myPhone == null){
          this.validatePhone = false;
          this.isValidMyPhone = false;
          this.errMsgPhone = 'Phone is required'
        }
        if (this.myConfirmPhone == '' || this.myConfirmPhone == null) {
          this.validatePhone = false;
          this.isValidConfirmPhone = false;
          this.errMsgConfirmPhone = 'Confirm phone is required'
        }
        if((this.myPhone != '' && this.myPhone != null) && (this.myConfirmPhone != '' && this.myConfirmPhone != null) ) {
          if(this.myPhone == this.myConfirmPhone) {
            this.validatePhone = true;
          }
          else {
            this.validatePhone = false;
            this.errMsgCommonPhone = 'Phone and Confirm phone values do not match'
          }
        }
      }
      if(this.updateContact.phone && !this.updateContact.email) {
        return this.validatePhone && this.isPhoneValidated && this.isConfirmPhoneValidated;
      }
      else if(this.updateContact.email && !this.updateContact.phone) {
        return this.validateEmail && this.isEmailValidated && this.isConfirmEmailValidated;
      }
      else {
        return (this.validateEmail && this.isEmailValidated && this.isConfirmEmailValidated) && (this.validatePhone && this.isPhoneValidated && this.isConfirmPhoneValidated);
      }
    },

    async resetValidate() {
      this.isValidMyEmail = true;
      this.isValidMyPhone = true;
      this.isValidConfirmEmail = true;
      this.isValidConfirmPhone = true;
      this.validateEmail = true;
      this.validatePhone = true;
      this.errMsgCommon = '';
      this.errMsgCommonPhone = '';
    },

    /**
     * Work differently from ModalContact's setEmail due to differences in props behavior.
     * @param data
     */
     setEmail(data) {
      this.myEmail = data.email;
      this.isEmailValidated = data.isValid;

      // move on if phone has also been validated
      if (this.verify && this.isEmailValidated && this.isPhoneValidated) {
        // this.continueToNextStep();
      }
      
    },

    setConfirmEmail(data) {
      this.myConfirmEmail = data.email;
      this.isConfirmEmailValidated = data.isValid;

      // move on if phone has also been validated
      if (this.verify && this.isConfirmEmailValidated && this.isConfirmPhoneValidated) {
        // this.continueToNextStep();
      }
      
    },
    /**
     * Work differently from ModalContact's setPhone due to differences in props behavior.
     * @param data
     */
    async setPhone(data) {
      this.myPhone = data.phone;
      this.isPhoneValidated = data.isValid;
      this.isPhoneValidated = await this.$refs.ContactPhone.invalidPhone;
      

      // move on if email has also been validated
      if (this.verify && this.isPhoneValidated ) {
        // this.continueToNextStep();
      }
    },

    async setConfirmPhone(data) {
      this.myConfirmPhone = data.phone;
      this.isConfirmPhoneValidated = data.isValid;
      this.isConfirmPhoneValidated = await this.$refs.ContactReenterPhone.invalidPhone;

      // move on if email has also been validated
      if (this.verify && this.isConfirmPhoneValidated ) {
        // this.continueToNextStep();
      }
    },

    resetVerify() {

    }
  }
}
</script>

<style lang="scss" scoped>
  .err-msg{
   color: var(--ri-red);
  }
  .component-container {

    .app-error-msg{
      color: var(--ri-red);
      margin-top: 5px;
    }
    .app-contact-inputs {
      .app-contact-info{
        .app-user-email{
          min-width: 350px;
        }
      }
      .app-input-group{
        margin-bottom: 0em !important;
      }
    } 
  }
</style>